import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

// withCredentials: send the session cookie on every request
const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      // Session gone – bounce to Microsoft login. Skip for public pages.
      const p = window.location.pathname;
      const isPublic = p === '/umzug' || p.startsWith('/umzug/') || p.startsWith('/auth/');
      if (!isPublic) {
        window.location.href = '/auth/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
